module.exports = __webpack_public_path__ + "static/PRlogo-9b36bc8013f912733de80d9609ce285a.png";